module.exports = ".card-header-border {\r\n    border-bottom: 1px solid #ddd !important;\r\n    padding: 10px !important;\r\n}"